import React from 'react';
import queryString from 'query-string';
import Spinner from 'components/ComponentSpinner/Spinner';
import { setToken, setBackTo } from 'utils/auth';

class ExternalTokenRedirect extends React.PureComponent {
  componentDidMount() {
    const token = window.location.pathname.match(/redirect\/(.*)$/)[1];

    if (token) {
      const qs = queryString.parse(window.location.search);

      if (qs.back_to) {
        setBackTo(qs.back_to);
      }

      setToken(token);

      const redirectUrl = qs.partner_registration
        ? '/partner_registration'
        : '/';

      setTimeout(() => {
        window.location.href = redirectUrl;
      }, 1300);
    }
  }

  render() {
    return <Spinner />;
  }
}

export default ExternalTokenRedirect;
